import { PropsWithChildren } from "react"
import classNames from "classnames"
import styled, { css } from "styled-components"

import { UITypes } from "types"

import styles from "./index.module.scss"

interface Props extends PropsWithChildren, UITypes.ButtonNew {}

const StyledButton = styled.span<{ disabled: boolean | undefined }>`
  user-select: none;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`

export const ButtonNew = ({
  color = "blueBordered",
  size = "auto",
  children,
  type,
  disabled,
  className,
  text,
  dataTestId,
  onClick,
}: Props) => {
  const attributes = {
    type,
    disabled,
    onClick,
    "data-testid": dataTestId,
    className: classNames(className, styles.buttonNew, {
      [styles[color]]: color,
      [styles[size]]: size,
    }),
  }

  return type === "submit" ? (
    <button {...attributes}>
      {text} {children}
    </button>
  ) : (
    <StyledButton {...attributes} disabled={disabled}>
      {text} {children}
    </StyledButton>
  )
}
